import { writable } from 'svelte/store';

export const darkModeEnabled = writable<boolean>(false);

// Set night mode button function
export function setNight() {
  darkModeEnabled.set(true);
  localStorage.setItem('darkModeEnabled', 'true');
  console.log('night mode set to true');
}

// Set day mode button function
export function setDay() {
  darkModeEnabled.set(false);
  localStorage.setItem('darkModeEnabled', 'false');
  console.log('night mode set to false');
}

// Initial theme according to user preference or OS preference if no user preference set
export function setTheme() {
  if (localStorage.getItem('darkModeEnabled')) {
    if (localStorage.getItem('darkModeEnabled') === 'true') {
      darkModeEnabled.set(true);
    } else {
      darkModeEnabled.set(false);
    }
  } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    darkModeEnabled.set(true);
  }
}

